module.exports = __webpack_public_path__ + "static/media/send.44c49b67.svg";